var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.375,
    height: 1.875,
    x: 2.813,
    y: 6.563,
    fill: "#FFF",
    rx: 0.938
  }))));
}
export default __webpack_public_path__ + "67defa7f9239a4df97196f291f1de93a.svg";
export { SvgIconHide as ReactComponent };